import { Link } from "react-router-dom";
import { motion } from "framer-motion";

const CARD_INITIAL = { opacity: 0, y: 28 };
const CARD_IN_VIEW = { opacity: 1, y: 0 };
const CARD_VIEWPORT = { once: true, amount: 0.2 };
const CARD_TRANSITION = { duration: 0.9, ease: [0.2, 0.7, 0.1, 1] };

export const RoomCard = ({ room, size = "md" }) => {
  const heights = {
    sm: "h-[320px] md:h-[360px]",
    md: "h-[420px] md:h-[520px]",
    lg: "h-[520px] md:h-[680px]",
  };
  return (
    <motion.div
      initial={CARD_INITIAL}
      whileInView={CARD_IN_VIEW}
      viewport={CARD_VIEWPORT}
      transition={CARD_TRANSITION}
    >
      <Link
        to={`/rooms/${room.slug}`}
        data-testid={`room-card-${room.slug}`}
        className="group block"
      >
        <div className={`relative overflow-hidden ${heights[size]} bg-paper-200`}>
          <img
            src={room.image}
            alt={room.name}
            className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-ink-900/65 via-ink-900/10 to-transparent" />
          <div className="absolute top-6 left-6">
            <span className="inline-block px-3 py-1 bg-paper-50/85 text-sage-dark text-[10px] tracking-[0.2em] uppercase font-semibold">
              {room.view}
            </span>
          </div>
          <div className="absolute bottom-6 left-6 right-6 flex items-end justify-between gap-4">
            <div>
              <div className="text-[10px] tracking-[0.24em] uppercase text-paper-100/90">
                {room.size_sqm} m² · {room.bed}
              </div>
              <h3 className="mt-2 font-serif text-3xl md:text-4xl text-paper-50">
                {room.name}
              </h3>
            </div>
            <div className="text-right shrink-0">
              <div className="text-[10px] tracking-[0.22em] uppercase text-paper-100/90">Tariff</div>
              <div className="font-serif italic text-base md:text-lg text-paper-50">
                On enquiry
              </div>
            </div>
          </div>
        </div>
      </Link>
    </motion.div>
  );
};

export default RoomCard;
